import React from 'react'
import '../components/GreenBan.css'
import SOLARPLANT from "../images/videos/VIDEOS/VID4.mp4";
export default function GreenBan() {

  const handleWhatsApp = () => {
    const phone = "919597839564";
    const message = encodeURIComponent(
      "Hello RAD EnviroNex Team 👋\n\n" +
      "I am interested in conducting a professional *Green Audit* for our campus/facility. " +
      "We would like to evaluate our environmental performance, water management, and sustainability practices.\n\n" +
      "Please let us know the process and the documentation required to initiate this assessment.\n\n" +
      "Looking forward to your professional support!"
    );

    window.open(`https://wa.me/${phone}?text=${message}`, "_blank");
  };



  return (
    <>




      <section className="hero">
        {/* VIDEO */}
        <video
          className="hero-video"
          src={SOLARPLANT}
          autoPlay
          loop
          muted
          playsInline
        />

        {/* OVERLAY */}
        <div className="hero-overlay"></div>

        {/* CONTENT */}
        <div className="hero-content">
          <div className="title-box animate-glow">
            <h1>GREEN AUDIT </h1>
            <p>Power Your Future with the Sun</p>

            <button className="quote-btn" onClick={handleWhatsApp}>
              Get Quote
            </button>
          </div>
        </div>
      </section>





    </>
  )
}
